import * as types from '../../actions/actionTypes';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_LOCATION_INFO_SUCCESS:
      return { ...state, ...action.data };
    case types.UPDATE_LOCATION_INFO_FAIL:
      return state;
    default:
      return state;
  }
};
